import createIcon from '../../createIcon';

/**
 * @component @name Co2
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNzUgNy41SDEwLjc1QzEwLjIgNy41IDkuNzUgNy45NSA5Ljc1IDguNVYxMi41QzkuNzUgMTMuMDUgMTAuMiAxMy41IDEwLjc1IDEzLjVIMTMuNzVDMTQuMyAxMy41IDE0Ljc1IDEzLjA1IDE0Ljc1IDEyLjVWOC41QzE0Ljc1IDcuOTUgMTQuMyA3LjUgMTMuNzUgNy41Wk0xMy4yNSAxMkgxMS4yNVY5SDEzLjI1VjEyWk03Ljc1IDExLjVWMTIuNUM3Ljc1IDEzLjA1IDcuMyAxMy41IDYuNzUgMTMuNUgzLjc1QzMuMiAxMy41IDIuNzUgMTMuMDUgMi43NSAxMi41VjguNUMyLjc1IDcuOTUgMy4yIDcuNSAzLjc1IDcuNUg2Ljc1QzcuMyA3LjUgNy43NSA3Ljk1IDcuNzUgOC41VjkuNUg2LjI1VjlINC4yNVYxMkg2LjI1VjExLjVINy43NVpNMjAuMjUgMTRIMTguMjVWMTVIMjEuMjVWMTYuNUgxNi43NVYxNEMxNi43NSAxMy40NSAxNy4yIDEzIDE3Ljc1IDEzSDE5Ljc1VjEySDE2Ljc1VjEwLjVIMjAuMjVDMjAuOCAxMC41IDIxLjI1IDEwLjk1IDIxLjI1IDExLjVWMTNDMjEuMjUgMTMuNTUgMjAuOCAxNCAyMC4yNSAxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Co2 = createIcon('Co2', [
  [
    'path',
    {
      d: 'M13.75 7.5H10.75C10.2 7.5 9.75 7.95 9.75 8.5V12.5C9.75 13.05 10.2 13.5 10.75 13.5H13.75C14.3 13.5 14.75 13.05 14.75 12.5V8.5C14.75 7.95 14.3 7.5 13.75 7.5ZM13.25 12H11.25V9H13.25V12ZM7.75 11.5V12.5C7.75 13.05 7.3 13.5 6.75 13.5H3.75C3.2 13.5 2.75 13.05 2.75 12.5V8.5C2.75 7.95 3.2 7.5 3.75 7.5H6.75C7.3 7.5 7.75 7.95 7.75 8.5V9.5H6.25V9H4.25V12H6.25V11.5H7.75ZM20.25 14H18.25V15H21.25V16.5H16.75V14C16.75 13.45 17.2 13 17.75 13H19.75V12H16.75V10.5H20.25C20.8 10.5 21.25 10.95 21.25 11.5V13C21.25 13.55 20.8 14 20.25 14Z',
      key: '1af6cu',
    },
  ],
]);

export default Co2;
